import React from 'react';

type Props = {
  isSelected: boolean;
  index: number;
  label: string;
  isDisabled?: boolean;
  onClick: (event: React.MouseEvent, newValue: number) => void;
};

const CustomTabHeader = (props: Props) => {
  const {
    isSelected,
    index,
    onClick,
    label,
    isDisabled = false,
    ...rest
  } = props;
  const tabClassNames = `v2-custom-tab-header ${isSelected ? 'selected' : ''}`;
  return (
    <button
      disabled={isDisabled}
      onClick={(e) => onClick(e, index)}
      {...rest}
      className={tabClassNames}
    >
      {label}
    </button>
  );
};

export default CustomTabHeader;
